export default __webpack_public_path__ + "static/media/nextArrow.7219bcfb.svg";